<template>
  <div
    data-tab-content
    :class="classList"
  >
    <slot />
  </div>
</template>

<script>
/**
 * TabContent.vue
 */
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {}
  },

  computed: {
    classList () {
      return [
        'absolute inset-0 overflow-hidden',
      ]
    },
  },
}
</script>
